export var AppetiteType;
(function (AppetiteType) {
    AppetiteType["Impact"] = "impact";
    AppetiteType["Likelihood"] = "likelihood";
    AppetiteType["Risk"] = "risk";
})(AppetiteType || (AppetiteType = {}));
//# sourceMappingURL=appetite-type.js.map